import Vue from "vue";
import Router from "vue-router";
import Main from "./views/layout/main.vue";
import store from "./store/store";
import tabRecursion from "@/common/plugins/tabRecursion";
import menu from "./store/modules/menu";
Vue.use(Router);

const router = new Router({
    mode: "history",
    // 跳转路由，重新设置屏幕滚动
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0
            };
        }
    },
    routes: [{
            path: "/",
            redirect: "/home"
        },
        {
            path: "/main",
            component: Main,
            name: "main",
            children: [{
                    path: "/home",
                    name: "home",
                    component: () => import("./views/pages/home.vue"),
                    meta: {
                        title: "首页",
                        author: false,
                        keepAlive: true
                    }
                },
                {
                    path: "/roleAdmin",
                    name: "roleAdmin",
                    component: () =>
                        import("./views/pages/admin/roleAdmin.vue"),
                    meta: {
                        title: "角色权限",
                        author: true,
                        keepAlive: true
                    }
                },
                {
                    path: "/menuAdmin",
                    name: "menuAdmin",
                    component: () => import("./views/pages/admin/menuAdmin.vue"),
                    meta: {
                        title: "菜单管理",
                        author: true,
                        keepAlive: true
                    }
                },
                {
                    path: "/roleBind",
                    name: "roleBind",
                    component: () => import("./views/pages/admin/roleBind.vue"),
                    meta: {
                        title: "角色绑定",
                        author: true,
                        keepAlive: true
                    }
                },
                {
                    path: "/userList",
                    name: "userList",
                    component: () => import("./views/pages/admin/userList.vue"),
                    meta: {
                        title: "用户主体列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/companyList",
                    name: "companyList",
                    component: () => import("./views/pages/admin/companyList.vue"),
                    meta: {
                        title: "企业列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/rankList",
                    name: "rankList",
                    component: () => import("./views/pages/admin/rankList.vue"),
                    meta: {
                        title: "等级列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/businessCodeList",
                    name: "businessCodeList",
                    component: () => import("./views/pages/admin/businessCodeList.vue"),
                    meta: {
                        title: "业务员邀请列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/expressList",
                    name: "expressList",
                    component: () => import("./views/pages/admin/expressList.vue"),
                    meta: {
                        title: "物流列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/productsSetList",
                    name: "productsSetList",
                    component: () => import("./views/pages/admin/productsSetList.vue"),
                    meta: {
                        title: "产品设置列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/lastMileList",
                    name: "lastMileList",
                    component: () => import("./views/pages/admin/lastMileList.vue"),
                    meta: {
                        title: "尾程列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/holidayList",
                    name: "holidayList",
                    component: () => import("./views/pages/admin/holidayList.vue"),
                    meta: {
                        title: "尾程列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/metafileds",
                    name: "metafileds",
                    component: () => import("./views/pages/admin/metafileds.vue"),
                    meta: {
                        title: "定制属性列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/channelList",
                    name: "channelList",
                    component: () => import("./views/pages/admin/channelList.vue"),
                    meta: {
                        title: "物流渠道列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/category",
                    name: "category",
                    component: () => import("./views/pages/admin/category.vue"),
                    meta: {
                        title: "分类树",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/iossList",
                    name: "iossList",
                    component: () => import("./views/pages/admin/iossList.vue"),
                    meta: {
                        title: "ioss",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/addressBook",
                    name: "addressBook",
                    component: () => import("./views/pages/admin/addressBook.vue"),
                    meta: {
                        title: "地址薄",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/couponList",
                    name: "couponList",
                    component: () => import("./views/pages/admin/couponList.vue"),
                    meta: {
                        title: "coupon",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/currencyList",
                    name: "currencyList",
                    component: () => import("./views/pages/admin/currencyList.vue"),
                    meta: {
                        title: "currency",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/rechargeExamine",
                    name: "rechargeExamine",
                    component: () => import("./views/pages/admin/rechargeExamine.vue"),
                    meta: {
                        title: "rechargeExamine",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/remark",
                    name: "remark",
                    component: () => import("./views/pages/admin/remark.vue"),
                    meta: {
                        title: "remark",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/orderSku",
                    name: "orderSku",
                    component: () => import("./views/pages/admin/orderSku.vue"),
                    meta: {
                        title: "orderSku",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/analysis",
                    name: "analysis",
                    component: () => import("./views/pages/admin/analysis.vue"),
                    meta: {
                        title: "analysis",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/goodsList",
                    name: "goodsList",
                    component: () => import("./views/pages/goodsAdmin/goodsList.vue"),
                    meta: {
                        title: "产品列表",
                        author: true,
                        keepAlive: false
                    },
                    children: [
                    {
                        path: "/goodsList/detail",
                        name: "goodsDetail",
                        component: () => import("./views/pages/goodsAdmin/goodsList/goodsDetail.vue"),
                        meta: {
                            title: "产品详情",
                            author: false,
                            keepAlive: false
                        }
                    }]
                },
                {
                    path: "/downloadList",
                    name: "downloadList",
                    component: () => import("./views/pages/goodsAdmin/downloadList.vue"),
                    meta: {
                        title: "下载列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/collectionList",
                    name: "collectionList",
                    component: () => import("./views/pages/goodsAdmin/collectionList.vue"),
                    meta: {
                        title: "收藏列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/privateProducts",
                    name: "privateProducts",
                    component: () => import("./views/pages/goodsAdmin/privateProducts.vue"),
                    meta: {
                        title: "私域列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/ordersList",
                    name: "ordersList",
                    component: () => import("./views/pages/ordersAdmin/ordersList.vue"),
                    meta: {
                        title: "订单列表",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/transactionDetails",
                    name: "transactionDetails",
                    component: () => import("./views/pages/fundManagement/transactionDetails.vue"),
                    meta: {
                        title: "交易明细",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/recharge",
                    name: "recharge",
                    component: () => import("./views/pages/fundManagement/recharge.vue"),
                    meta: {
                        title: "充值",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/statement",
                    name: "statement",
                    component: () => import("./views/pages/fundManagement/statement.vue"),
                    meta: {
                        title: "账号",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/invoice",
                    name: "invoice",
                    component: () => import("./views/pages/fundManagement/invoice.vue"),
                    meta: {
                        title: "发票",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/shopifyList",
                    name: "shopifyList",
                    component: () => import("./views/pages/listingAdmin/shopifyList.vue"),
                    meta: {
                        title: "刊登管理",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/shoplazzaList",
                    name: "shoplazzaList",
                    component: () => import("./views/pages/listingAdmin/shoplazzaList.vue"),
                    meta: {
                        title: "刊登管理",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/shoplineList",
                    name: "shoplineList",
                    component: () => import("./views/pages/listingAdmin/shoplineList.vue"),
                    meta: {
                        title: "刊登管理",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/listingRecord",
                    name: "listingRecord",
                    component: () => import("./views/pages/listingAdmin/listingRecord.vue"),
                    meta: {
                        title: "刊登批次管理",
                        author: true,
                        keepAlive: true
                    },
                },
                {
                    path: "/storeList",
                    name: "storeList",
                    component: () =>
                        import("./views/pages/storePlatform/storeList.vue"),
                    meta: {
                        title: "店铺列表",
                        author: true,
                        keepAlive: true
                    }
                },
                {
                    path: "/platformList",
                    name: "platformList",
                    component: () =>
                        import("./views/pages/storePlatform/platformList.vue"),
                    meta: {
                        title: "平台列表",
                        author: true,
                        keepAlive: true
                    }
                },
                {
                    path: "/shoppingCart",
                    name: "shoppingCart",
                    component: () =>
                        import("./views/pages/shoppingCart/shoppingCart.vue"),
                    meta: {
                        title: "购物车",
                        author: true,
                        keepAlive: true
                    }
                },
                {
                    path: "/shipping",
                    name: "shipping",
                    component: () =>
                        import("./views/pages/shipping/shipping.vue"),
                    meta: {
                        title: "购物",
                        author: true,
                        keepAlive: true
                    }
                },
                {
                    path: "/payment",
                    name: "payment",
                    component: () =>
                        import("./views/pages/payment/payment.vue"),
                    meta: {
                        title: "下单",
                        author: true,
                        keepAlive: true
                    }
                },
                {
                    path: "/externalLinks",
                    name: "externalLinks",
                    component: () =>
                        import("./views/pages/admin/externalLink.vue"),
                    meta: {
                        title: "外部链接列表",
                        author: true,
                        keepAlive: true
                    }
                },
                {
                    path: "/notification",
                    name: "notification",
                    component: () =>
                        import("./views/pages/admin/notification.vue"),
                    meta: {
                        title: "用户设置",
                        author: true,
                        keepAlive: true
                    }
                },
                {
                    path: "/shippingRules",
                    name: "shippingRules",
                    component: () => import("./views/pages/admin/shippingRules.vue"),
                    meta: {
                        title: "运费规则",
                        author: true,
                        keepAlive: true
                    },
                },
            ]
        },
        {
            path: "/login",
            name: "login",
            component: () => import("./views/pages/login/login.vue"),
            meta: {
                title: "login",
                author: true
            }
        },
        {
            path: "/forgot",
            name: "forgot",
            component: () => import("./views/pages/forgot/forgot.vue"),
            meta: {
                title: "forgot",
                author: true
            }
        },
        {
            path: "/register",
            name: "register",
            component: () => import("./views/pages/register/register.vue"),
            meta: {
                title: "register",
                author: true
            }
        },
        {
            path: "/activate",
            name: "activate",
            component: () => import("./views/pages/activate/activate.vue"),
            meta: {
                title: "activate",
                author: true
            }
        },
        {
            path: "*",
            name: "404",
            component: () => import("./views/pages/404.vue"),
            meta: {
                title: "404",
                author: false
            }
        },
    ]
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem("token");
    if (token) {
        store.commit("MENUBREAD", [])
        let menu_id = tabRecursion(
            "/" + to.name,
            JSON.parse(localStorage.getItem("menu_list"))
            );
        localStorage.setItem("menu_id", menu_id);
        store.commit("MENU_ID", menu_id);
        store.commit("IS_INFOTAGS", 'normal');
        // store.dispatch("getMenuAuth");
        const keyword = window.location.search.split('?keyword=')[1];
        store.commit("SETKEYWORD", keyword || "");
        next();
    } else if (to.query.token) {
        localStorage.setItem("token", to.query.token);
        store.commit("MENUBREAD", [])
        store.dispatch("getMenuListByRoles").then(res => {
            let menu_id = tabRecursion(
                "/" + to.name,
                res
            );
            localStorage.setItem("menu_id", menu_id);
            next(to.path);
        });
    } else if (["/login", "/register", "/forgot", "/activate"].includes(to.path)) {
        next();
    } else {
        // sessionStorage.setItem("path", window.location.pathname + window.location.search);
        next(`./login?ref=${encodeURIComponent(location.href)}`);
    }

});

export default router;